import { useUpdateQuery } from "@/hooks/use-update-query";
import { DateOption } from "@/utils/date-options";

import { ToggleButtons } from "ui/widget/toggle-buttons";

import { dateOptions } from "../data/date-options";

type Props = {
  dateOption: DateOption;
};

export const ChartDateOptionButtonGroup = ({ dateOption }: Props) => {
  const { updateQuery } = useUpdateQuery();

  return (
    <ToggleButtons
      itemClassName="tracking-widest bg-transparent rounded-lg text-zinc-500 text-sm font-bold hover:text-zinc-800"
      selectedItemClassName="bg-sky-100 shadow-none text-sky-600 hover:text-sky-600"
      fullWidth={false}
      options={dateOptions.map((option) => ({ value: option }))}
      value={dateOption}
      onChange={(value) => {
        updateQuery({
          name: "dateOption",
          value,
        });
      }}
    />
  );
};
